import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, OnDestroy, OnInit, Output, } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { NumberInputComponent } from '../../shared/components/number-input/number-input.component';
import { applicationSettingEnum } from '../../shared/enums/application-settings.enum';
import { OfflineService } from '../../shared/services/offline.service';
import { RegistryApiService } from '../../shared/services/registry-api.service';
import { EventSearchForm } from './event-search.form';

@Component({
    selector: 'app-event-search-form',
    standalone: true,
    providers: [RegistryApiService],
    imports: [CommonModule, ReactiveFormsModule, NumberInputComponent],
    templateUrl: './event-search-form.component.html',
})
export class EventSearchFormComponent implements OnInit, OnDestroy {
    private readonly unsubscribe = new Subject<void>();
    private readonly offlineService = inject(OfflineService);
    private readonly registryApiService = inject(RegistryApiService);

    @Input() public showSearchForm: boolean = false;
    @Input() public eventSearchForm!: EventSearchForm;
    @Output() protected toggleShowFilter: EventEmitter<void> = new EventEmitter<void>();

    protected isOnline!: boolean;
    protected eventSearchFuture: string = 'N/A';

    /** Initializes application setting values with fallbacks. */
    private readonly initApplicationSettings = (): void => {
        this.registryApiService
            .getAppSetting(applicationSettingEnum.trainingProviderEventSearchFuture,)
            .then((result: string) => { this.eventSearchFuture = result; });
    };

    ngOnInit(): void {
        this.initApplicationSettings();

        this.offlineService.isOnline$
            .pipe(takeUntil(this.unsubscribe))
            .subscribe({
                next: (value: boolean) => {
                    this.isOnline = value;
                },
            });
    }

    ngOnDestroy(): void {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }

    protected showFilter = (): void => {
        //toggles the form method that toggles if the filter should be shown or not in the small view
        this.toggleShowFilter.emit();
    };

    protected search = (): void => {
        //toggles the form method that toggles if the filter should be shown or not in the small view
        this.toggleShowFilter.emit();
        this.eventSearchForm.search();
    };

    protected reset = (): void => {
        this.eventSearchForm.reset();
    };
}
